const maleGenital =
[
{symptom:"prProstate",
displayAs:"Prostate feels malignant on PR",
questionGroup: "prostate"
},

{symptom: "erectileDysfunction",
displayAs: "Erectile dysfunction",
questionGroup: "ed"
},

{symptom: "testisEnlargement",
displayAs: "Painless testicular enlargement",
questionGroup: "testisSize"
},

{symptom: "testisShape",
displayAs: "Change in testicular shape / texture",
questionGroup: "testisAbnormal"
},

{symptom: "testisOther",
displayAs: "Other unexplained or persistent testicular symptoms",
questionGroup: "sideDescriptionDuration",
},

{symptom: "sti",
displayAs: "Untreated STI",
questionGroup: "sti",
},

{symptom: "penileMass",
displayAs: "Penile mass / ulcer",
questionGroup: "penileMass",
},

{symptom: "foreskin",
displayAs: "Unexplained or persistent foreskin / glans symptoms",
questionGroup: "foreskin",
}

]
 export default maleGenital